/* mh-gallery-carousel.js - added 2026-08-26.

   Drives snippets/mh-product-gallery.liquid: one main image on a scroll-snap
   track, a thumbnail rail, and a jump to the matching slide when a variant
   is picked.

   Deliberately SEPARATE from mh-pdp.js, which already owns variant
   selection, zoom, the size guide and the sticky buy bar. Folding this in
   would have meant rewriting that whole file to add one feature.

   TWO THINGS THAT BIT, do not undo them:

   1. The hidden <select data-mh-variant-id> is looked up INSIDE the handler,
      never once at startup. Shopify's script_tag filter emits a plain, NON
      deferred <script>, and this snippet sits above the buy column, so at
      execution time the select does not exist yet. Caching it in a variable
      stored null and the variant jump silently never fired.

   2. mh-pdp.js writes the new variant id by setting .value directly, which
      fires no change event and is invisible to MutationObserver. So we
      listen for the click on the option button and read the select on the
      next tick, after mh-pdp.js has run its own handler. */
(function () {
  'use strict';

  var gal = document.querySelector('[data-mh-gallery]');
  if (!gal) return;

  var track = gal.querySelector('[data-mh-track]');
  if (!track) return;
  var slides = track.querySelectorAll('[data-slide]');
  if (slides.length < 2) return;

  var thumbs = gal.querySelectorAll('[data-mh-thumbs] [data-thumb]');
  var count  = gal.querySelector('[data-mh-count]');
  var prev   = gal.querySelector('[data-mh-prev]');
  var next   = gal.querySelector('[data-mh-next]');

  var map = {};
  var mapEl = gal.querySelector('[data-mh-media-map]');
  if (mapEl) { try { map = JSON.parse(mapEl.textContent); } catch (e) { map = {}; } }

  function current() {
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function paint(i) {
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].setAttribute('aria-current', String(+thumbs[t].dataset.thumb === i));
    }
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= slides.length - 1;
    var active = thumbs[i];
    if (active && active.scrollIntoView) {
      active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function sync() { paint(current()); }

  /* paint() before the scroll so the counter and the active thumbnail react
     immediately; a smooth scroll across ten slides takes most of a second
     and the label should not lag behind the tap. */
  function go(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    paint(i);
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }

  var tick;
  track.addEventListener('scroll', function () {
    clearTimeout(tick);
    tick = setTimeout(sync, 80);
  }, { passive: true });

  gal.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (t) { go(+t.dataset.thumb); return; }
    if (e.target.closest('[data-mh-prev]')) go(current() - 1);
    if (e.target.closest('[data-mh-next]')) go(current() + 1);
  });

  /* A swipe that ends over a slide still fires a click, which would open
     mh-pdp.js's zoom dialog. That handler is bound on the slide itself, so a
     CAPTURE listener on the track runs first and can cancel it. */
  var movedAt = 0;
  track.addEventListener('scroll', function () { movedAt = Date.now(); }, { passive: true });
  track.addEventListener('click', function (e) {
    if (Date.now() - movedAt < 350) { e.stopPropagation(); e.preventDefault(); }
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mh-option-value]')) return;
    setTimeout(function () {
      var sel = document.querySelector('[data-mh-variant-id]');   /* see note 1 */
      if (!sel) return;
      var slide = map[sel.value];
      if (typeof slide === 'number') go(slide);
    }, 0);
  });

  window.addEventListener('resize', sync);
  sync();
})();
